import React, { Component } from 'react'

import Auth from 'j-toker'
import { X } from 'react-feather'
import {
  Link,
  NavLink,
} from 'react-router-dom'

import Facebook from '../images/facebook.svg'
import InputEmail from '../inputs/input-email'
import InputPassword from '../inputs/input-password'

class HeaderLogin extends Component {
  constructor(props) {
    super(props);
    this.loginLightboxRef = React.createRef();
    this.state = {
      email: '',
      password: '',
      error: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.loginLightboxRef.current.classList.remove('lightbox--transitioning');
    },10)
  }

  onChange = (e) => {
    e.preventDefault();
    let stateChange = {};
    stateChange[e.target.name] = e.target.value;
    stateChange['error'] = '';
    this.setState(stateChange);
  }

  onFacebook = (e) => {
    e.preventDefault();
    Auth.oAuthSignIn({provider: 'facebook'})
    .then((data) => {
      const _payload = Object.assign({},{
          bio: "",
          newsletter_email: false,
          notifications_email: true
        },(data.payload || {}));
      Auth.updateAccount({
        payload: _payload
      })
      .then((res) => {
        window.location = `/`;
      });
    })
    .fail((data) => {
      console.log(data);
    });
  }


  onLoginClick = (e) => {
    e.preventDefault();
    Auth.emailSignIn({
      email: this.state.email,
      password: this.state.password
    })
    .then((response) => {
      if(this.props.destination) {
        window.location = decodeURIComponent(this.props.destination);
      } else {
        window.location = window.location.href.replace('?login','');
      }
    })
    .catch((err) => {
      const reason = err.reason == "Invalid credentials." ? "We can't find an account with that email and password combination." : err.reason;
      this.setState({error: reason});
    })
  }

  onCloseLogin = (e) => {
    this.loginLightboxRef.current.classList.add('lightbox--transitioning');
    setTimeout(() => {
      this.props.onToggleLogin(e);
    },300)
  }

  onSignupClick = (e) => {
    e.preventDefault();
    this.props.onToggleLogin(e);
    if(this.props.destination) {
      window.location = (`/account/sign-up?destination=${this.props.destination}`);
    } else {
      window.location = (`/account/sign-up?destination=${encodeURIComponent(window.location.pathname)}`);
    }
  }

  onRecoverClick = (e) => {
    e.preventDefault();
    this.props.onToggleLogin(e);
    window.location = (`/account/recover`);
  }

  render() {
    return (
      <div className="lightbox lightbox--login lightbox--transitioning" ref={this.loginLightboxRef}>
        <div className="lightbox__content">
          <button className="button--close" onClick={this.onCloseLogin}><X /></button>
          <aside className={`lightbox__aside ${this.state.error ? "lightbox__aside--error" : ""}`}>
            <h2 className="text--mid-header">👋 Welcome, camper!</h2>
            <div>
              <p>Podcast Campfire is a meeting place for the podcasting community.</p>
              <p>It's a global community of people creating and enthusiastic about the podcasting world, brought together to share news, updates, and jobs in the medium we all love.</p>
            </div>
          </aside>
          <main className="lightbox__main lightbox__main--login">
            <figure className="user__element user__element--headline">
              <h2 className="headline__title"><b>Log in</b></h2>
            </figure>
            {this.state.error && <p className="text--invalid">{this.state.error}</p>}
            <section className="signup__facebook">
              <button onClick={this.onFacebook} className="button button--facebook"><img src={Facebook} /> Log in with Facebook</button>
              <p className="text--descriptor">or</p>
            </section>
            <form noValidate onSubmit={this.onLoginClick}>
              <InputEmail
                label="Email"
                name="email"
                value={this.state.email}
                onChange={this.onChange}
              />
              <InputPassword
                label="Password"
                name="password"
                value={this.state.password}
                onChange={this.onChange}
              />
              <button type={`submit`} className="button">Sign in</button>
            </form>
            <p className="text--descriptor">Not a Podcast Campfire member? <button className="link link--inline" onClick={this.onSignupClick}>Sign up</button>!</p>
            <p className="text--descriptor">Forgot your password? <button className="link link--inline" onClick={this.onRecoverClick}>Recover your account</button>.</p>
            </main>
        </div>
      </div>
    );
  }
}

export default HeaderLogin;



// WEBPACK FOOTER //
// ./src/app/components/headers/header-login.jsx